import React, { useEffect, useRef } from "react";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import "./FormDropdown.css";

interface FormDropdownProps {
  isVisible: boolean;
  setIsVisible: (value: boolean) => void;
  value: number;
  setValue: (value: number) => void;

  error: string;
  title: string;
}

const FormDropdown: React.FC<FormDropdownProps> = ({
  isVisible,
  setIsVisible,
  value,
  setValue,
  title,
  error,
}) => {
  const gradeDropdownRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        gradeDropdownRef.current &&
        !gradeDropdownRef.current.contains(event.target as Node)
      ) {
        console.log("Clicked outside the component");
        setIsVisible(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  console.log({ isVisible });
  return (
    <div id="gradeDropdown" ref={gradeDropdownRef} className="dropdown-parent">
      <div className="form-dropdown-title">{title}</div>
      <Dropdown
        show={isVisible}
        onClick={() => {
          setIsVisible(!isVisible);
        }}
      >
        <Dropdown.Toggle className="dropdown-input">
          {value === 0 ? "Select Grade" : `Grade ${value}`}
        </Dropdown.Toggle>

        {isVisible && (
          <Dropdown.Menu
            style={{
              display: "flex",
              flexDirection: "column",
              zIndex: 999,
              backgroundColor: "rgba(251,251,251,0.5)",
            }}
          >
            <Dropdown.Item
              onClick={() => {
                setValue(5);
                sessionStorage.setItem("grade", "5");
              }}
              className="dropdown-item"
            >
              grade 5
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setValue(6);
                sessionStorage.setItem("grade", "6");
              }}
              className="dropdown-item"
            >
              grade 6
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setValue(7);
                sessionStorage.setItem("grade", "7");
              }}
              className="dropdown-item"
            >
              grade 7
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setValue(8);
                sessionStorage.setItem("grade", "8");
              }}
              className="dropdown-item"
            >
              grade 8
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setValue(9);
                sessionStorage.setItem("grade", "9");
              }}
              className="dropdown-item"
            >
              grade 9
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setValue(10);
                sessionStorage.setItem("grade", "10");
              }}
              className="dropdown-item"
            >
              grade 10
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setValue(11);
              }}
              className="dropdown-item"
            >
              grade 11
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => {
                setValue(12);
              }}
              className="dropdown-item"
            >
              grade 12
            </Dropdown.Item>
          </Dropdown.Menu>
        )}
        {error && <div className="error-message">{error}</div>}
      </Dropdown>
    </div>
  );
};

export default FormDropdown;
